<template>
  <div class="step-header">
    <span class="step-circle">{{ number }}</span>
    <div class="step-title">
      {{ getLangString(langStringId) }}
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'

export default {
  name: 'step-header',
  props: {
    number: {
      type: Number,
      required: true
    },
    langStringId: {
      type: String,
      required: true
    }
  },
  computed:  {
    ...mapGetters('somnambulistui', ['getLangString'])
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.step-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 2em;
  .step-circle {
    position: relative;
    width: 2em;
    height: 2em;
    font-size: 1.75em;
    border-radius: 100%;
    background: var(--main-badge-background-color-inverse);
    color: var(--main-badge-text-color-inverse);
    box-shadow: var(--main-badge-drop-shadow);
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 0.5em;
  }
  .step-title {
    font-size: 1.4em;
    font-weight: 600;
    color: var(--main-text-heading-color);
  }
  .step-description {
    font-size: 1.2em;
  }
}

</style>
